import PropTypes from 'prop-types';

import { StatusBadge } from '#/modules/commonComponents/badge';
import { formatWorkOrderStatusLabel } from '#/modules/momMgmt/workOrder/helper/workOrderStatus';

const WorkOrderStatusBadge = ({ status, size = 'default', className }) => (
  <StatusBadge
    status={status}
    label={formatWorkOrderStatusLabel(status)}
    size={size}
    className={className}
  />
);

WorkOrderStatusBadge.propTypes = {
  status: PropTypes.string,
  size: PropTypes.oneOf(['default', 'sm']),
  className: PropTypes.string,
};

export default WorkOrderStatusBadge;
